import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import Signage from './components/Signage';
import { PageLoader } from "freespace-react-components";
import "freespace-react-components/style.css";
import './App.css';



class App extends Component {
  constructor(props) {
    super(props);
    this.windowProps = {};
  }

  componentDidMount() {
    this.windowProps = {
      height: this.divRef.offsetHeight,
      width: this.divRef.offsetWidth,
    };
  }

  render() {
    const { signageState } = this.props;
    const child = signageState.isLoading
      ? <PageLoader loading={true} />
      : <Signage signageState={signageState} windowProps={this.windowProps} />;

    const classes = ['App'];
    if (signageState.isLoading) {
      classes.push('App-full');
    }
    return (
      <div className={classes.join(' ')} ref={element => { this.divRef = element; }}>
        {child}
      </div>
    );
  }
}

export default inject('signageState')(observer(App));
